import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { FileReaderEvent } from '../../../setup-implement/setup-implement.component';
import { InductionSlides } from '../../../setup-induction-question/setup-induction-question';
import { CreateSlideVM, UpdateSlideVM } from '../../setup-induction-slides';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData{
  edit:boolean;
  Name:string;
  slide:InductionSlides;
  SectionID:number;
}

@Component({
  selector: 'app-dialog-add-slide',
  templateUrl: './dialog-add-slide.component.html',
  styleUrls: ['./dialog-add-slide.component.css']
})
export class DialogAddSlideComponent implements OnInit {
  imageURL: string | ArrayBuffer;
  

  constructor(

    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<DialogAddSlideComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
  ) { }

  Edit:boolean;
  Name:string;
  slide:InductionSlides;
  ImagePreview:string;
  SelectedSlideType:number;
  YoutubeVideoId:string;
  message:string;
  imagePath:string;
  SectionID:number;


  ngOnInit() {
    if(this.data.edit){

      //get slide details
      this._inductionService.GetSlideInfoById(this.data.slide.ID).subscribe(res=>{
        console.log("GetSlideInfoById",res)
        if(res.SlideTypeId == 1){
          this.data.slide.Slide=res.SlideData
          //this.ImagePreview = this.data.slide.Slide;
        }else if(res.SlideTypeId == 2){
          this.YoutubeVideoId = res.URL;
        }
        this.SelectedSlideType = res.SlideTypeId;
      })

      this.Edit = this.data.edit
      this.Name=this.data.slide.Title;
      this.slide = this.data.slide;

      

    
      
    }else{
      this.SectionID=this.data.SectionID
    }
  }

  getImage(image: string) {
    // return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);

}

onFileChanged(event) {
  

  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();

    reader.readAsDataURL(event.target.files[0]); // read file as data url

    reader.onload = (event:any) => { // called once readAsDataURL is completed
        var imageUrl = (event.target["result"]);
        this.ImagePreview = imageUrl;
    }
}

}

onNoClick(): void {
  this.dialogRef.close();
}

onSubmitClick(): void {

  if(this.Edit==true){
    let params = new UpdateSlideVM();
    params.slideId = this.slide.ID
    params.slideName=this.Name
    params.selectionId = this.slide.SlideSelectionId;
    params.order=0;
    params.active=this.slide.Active;
    //get image base64
    if(this.ImagePreview){
      var sImageUrl = this.ImagePreview.replace(/^data:image\/[a-z]+;base64,/, "");
      sImageUrl = this.ImagePreview.replace(/^data:image\/\w+;base64,/, "");
      params.slidedData=this.ImagePreview
    }
    params.SlideType = this.SelectedSlideType;
    params.Url=this.YoutubeVideoId;
     
  console.log("params",params)
  
    this._inductionService.UpdateSlides(params).subscribe(res=>{
      if(res.m_Item1){
        this.dialogRef.close(true);
      }else{
        alert("Error")
      }
      
    })
  }else{
    let params = new CreateSlideVM();
    
    params.slideName=this.Name
    params.selectionId = this.SectionID;
    params.order=0;
    
    //get image base64
    if(this.ImagePreview){
      var sImageUrl = this.ImagePreview.replace(/^data:image\/[a-z]+;base64,/, "");
      sImageUrl = this.ImagePreview.replace(/^data:image\/\w+;base64,/, "");
      params.slideData=this.ImagePreview
    }
    params.SlideType = this.SelectedSlideType;
    params.URL=this.YoutubeVideoId;
     
  console.log("params",params)
  
    this._inductionService.CreateSlide(params).subscribe(res=>{
      if(res.m_Item1){
        this.dialogRef.close(true);
      }else{
        alert("Error")
      }
      
    })
  }
  

  
}

}
